// Paths
var assetCdnUrl = '//macaronandme.com/cdn/shop/t/21/assets/__URL__?v=7805';

// Config
var personalization_type = null;
var personalization_previous_type = null;
var personalization_font = null;
var personalization_date_font = null;
var personalization_texture = new Image();
//var personalization_colors = [ "Black", "White", "Cream", "Brown", "Navy", "Blue", "Aqua", "Gray", "Pale Blue", "Bright Pink", "Light Pink", "Purple", "Red", "Yellow", "Lime", "Orange" ];

//added new personalization colors js array to handle hex codes now
var personalization_colors_json = [
    {
        "color": "Black",
      	"hex": null
    },
    {
        "color": "White",
      	"hex": null
    },
    {
        "color": "Cream",
      "hex": null
    },
    {
        "color": "Brown",
      	"hex": null
    },
    {
        "color": "Navy",
      	"hex": null
    },
    {
        "color": "Gray",
      	"hex": null
    },
    {
        "color": "Pale Blue",
      	"hex": null
    },
    {
        "color": "Chalk Pink",
      	"hex": null
    },
    {
        "color": "Purple",
      	"hex": null
    },
    {
        "color": "Mauve",
      	"hex": null
    },
    {
        "color": "Light Teal",
      	"hex": null
    },
    {
        "color": "Dark Teal",
      	"hex": null
    },
    {
        "color": "Mustard",
      	"hex": null
    },
    {
        "color": "Dark Gray",
      	"hex": null
    },
  {
    "color": "Dove Gray",
    "hex": null
  },
  {
    "color": "Blush",
    "hex": null
  },
  {
    "color": "Sage",
    "hex": null
  },
  {
    "color": "Cloud Blue",
    "hex": null
  },
  {
    "color": "Slate",
    "hex": null
  },
  {
    "color": "Wheat",
    "hex": null
  },
  {
    "color": "Pale Pink",
    "hex": null
  },
  {
    "color": "Pale Blue",
    "hex": null
  },
  {
    "color": "Forest Green",
    "hex": null
  },
  {
    "color": "Deep Blush",
    "hex": null
  },
  {
    "color": "Rockport Blue",
    "hex": null
  },
  {
    "color": "Taupe",
    "hex": null
  },
  {
    "color": "Sienna",
    "hex": null
  },
  {
    "color": "Oak",
    "hex": null
  },
  {
    "color": "Fawn",
    "hex": null
  }
];

var personalization_background_colors = [
  {
    "color": "meta-pink",
    "hex": null
  },
  {
    "color": "meta-cream",
    "hex": null
  },
  {
    "color": "meta-dark-gray",
    "hex": null
  },
  {
    "color": "meta-dark-teal",
    "hex": null
  },
  {
    "color": "meta-light-teal",
    "hex": null
  },
  {
    "color": "meta-medium-blue",
    "hex": null
  },
  {
    "color": "meta-new-gray",
    "hex": null
  },
  {
    "color": "meta-new-navy",
    "hex": null
  },
  {
    "color": "meta-oatmeal",
    "hex": null
  },
  {
    "color": "meta-white",
    "hex": null
  },
  {
    "color": "meta-coral-pink",
    "hex": null
  },
  {
    "color": "meta-slate",
    "hex": null
  },
  {
    "color": "meta-rust",
    "hex": null
  },
  {
    "color": "meta-blush",
    "hex": null
  },
  {
    "color": "meta-sage",
    "hex": null
  },
  {
    "color": "meta-wheat",
    "hex": null
  },
  {
    "color": "meta-gray",
    "hex": null
  },
  {
    "color": "meta-cloud-blue",
    "hex": null
  },
  {
    "color": "meta-dove-gray",
    "hex": null
  },
  {
    "color": "meta-dove-grey",
    "hex": null
  },
  {
    "color": "meta-pale-blue",
    "hex": null
  },
  {
    "color": "meta-forest-green",
    "hex": null
  },
  {
    "color": "meta-deep-blush",
    "hex": null
  },
  {
    "color": "meta-rockport-blue",
    "hex": null
  },
  {
    "color": "meta-taupe",
    "hex": null
  },
  {
    "color": "meta-sienna",
    "hex": null
  },
  {
    "color": "meta-oak",
    "hex": null
  },
  {
    "color": "meta-fawn",
    "hex": null
  }
];




//removed "Campus" from the array personalization_font and personalization_fontFiles" - smjr -2019-08-04
/*
var fontJSON = [
  {
    "fontTitle": "Century",
    "fontType": "standard",
    "fontName": "Century",
    "cartName": "Century",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/century.scss.css?v=77077481607598733851781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Copperplate",
    "fontType": "standard",
    "fontName": "Copperplate",
    "cartName": "Copperplate",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/copperplate.scss.css?v=71545306146090250811781304538",
    "enabled": false,
    "fontVariant": "unset",
    "useInitials": false,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Garamond",
    "fontType": "standard",
    "fontName": "Garamond",
    "cartName": "Garamond",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/garamond.scss.css?v=133010897219037841341781304538",
    "enabled": false,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Campus",
    "fontType": "standard",
    "fontName": "Campus",
    "cartName": "Campus",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/campus.scss.css?v=101015386268910872151781304538",
    "enabled": false,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Signet Roundhand",
    "fontType": "standard",
    "fontName": "Signet Roundhand",
    "cartName": "Signet Roundhand",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/signet-roundhand.scss.css?v=58191784081289277801781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Deco Block",
    "fontType": "typekit",
    "fontName": "apertura",
    "cartName": "Deco Block",
    "defaultWeight": 800,
    "fontStylesheet": "https://use.typekit.net/qjh6bgh.css",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Clarendon",
    "fontType": "typekit",
    "fontName": "clarendon-wide",
    "cartName": "Clarendon",
    "defaultWeight": 700,
    "fontStylesheet": "https://use.typekit.net/qjh6bgh.css",
    "enabled": true,
    "fontVariant": "uppercase",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 0.8
  },
  {
    "fontTitle": "ITC Avant Garde Gothic Pro",
    "fontType": "typekit",
    "fontName": "itc-avant-garde-gothic-pro",
    "cartName": "ITC Avant Garde Gothic Pro",
    "defaultWeight": 500,
    "fontStylesheet": "https://use.typekit.net/qjh6bgh.css",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "LTC Bodoni 175",
    "fontType": "typekit",
    "fontName": "ltc-bodoni-175",
    "cartName": "LTC Bodoni 175",
    "defaultWeight": 400,
    "fontStylesheet": "https://use.typekit.net/qjh6bgh.css",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "Adobe Garamond Pro",
    "fontType": "typekit",
    "fontName": "adobe-garamond-pro",
    "cartName": "Adobe Garamond Pro",
    "defaultWeight": 700,
    "fontStylesheet": "https://use.typekit.net/qjh6bgh.css",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": false,
    "fontScale": 1
  },
  {
    "fontTitle": "CircleBlock",
    "fontType": "standard",
    "fontName": "CircleBlock",
    "cartName": "CircleBlock",
    "defaultWeight": "normal",
    "fontStylesheet": "",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": false,
    "useName": false,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "CircleScript",
    "fontType": "standard",
    "fontName": "CircleScript",
    "cartName": "CircleScript",
    "defaultWeight": "normal",
    "fontStylesheet": "",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": false,
    "useName": false,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Diamond",
    "fontType": "standard",
    "fontName": "Diamond",
    "cartName": "Diamond",
    "defaultWeight": "normal",
    "fontStylesheet": "",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": false,
    "useName": false,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Century Gothic",
    "fontType": "standard",
    "fontName": "Century Gothic",
    "cartName": "Century Gothic",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/centurygothic.scss.css?v=116193959456748551731781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "CFDiamond",
    "fontType": "standard",
    "fontName": "CFDiamond",
    "cartName": "CFDiamond",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/CFDiamond.scss.css?v=154136213743824432351781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Code-Bold",
    "fontType": "standard",
    "fontName": "Code-Bold",
    "cartName": "Code-Bold",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/Code-Bold.scss.css?v=28176766245982794581781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Diamond Dreams",
    "fontType": "standard",
    "fontName": "Diamond Dreams",
    "cartName": "Diamond Dreams",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/DiamondDreams.scss.css?v=98615330752125570641781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Berlin",
    "fontType": "standard",
    "fontName": "Berlin",
    "cartName": "Berlin",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/BerlinMonogram.scss.css?v=121553966723129129931781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Hello Honey",
    "fontType": "standard",
    "fontName": "Hello Honey",
    "cartName": "Hello Honey",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/hellohoney.scss.css?v=12989146829243757691781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Keep Calm",
    "fontType": "standard",
    "fontName": "Keep Calm",
    "cartName": "Keep Calm",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/keepcalm.scss.css?v=47950389870007592311781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Madina",
    "fontType": "standard",
    "fontName": "Madina",
    "cartName": "Madina",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/madina.scss.css?v=82225873244192772631781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Mongolian Baiti",
    "fontType": "standard",
    "fontName": "Mongolian Baiti",
    "cartName": "Mongolian Baiti",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/MongolianBaiti.scss.css?v=130912727656119535401781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Nathalia",
    "fontType": "standard",
    "fontName": "Nathalia",
    "cartName": "Nathalia",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/nathalia.scss.css?v=171543492905342124201781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Neothic",
    "fontType": "standard",
    "fontName": "Neothic",
    "cartName": "Neothic",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/neothic.scss.css?v=140981187489988212801781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Parisienne",
    "fontType": "standard",
    "fontName": "Parisienne",
    "cartName": "Parisienne",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/parisienne.scss.css?v=14495454505688555231781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Pistara",
    "fontType": "standard",
    "fontName": "Pistara",
    "cartName": "Pistara",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/pistara.scss.css?v=181422409046256971591781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  },
  {
    "fontTitle": "Wensley",
    "fontType": "standard",
    "fontName": "Wensley",
    "cartName": "Wensley",
    "defaultWeight": "normal",
    "fontStylesheet": "//macaronandme.com/cdn/shop/t/21/assets/wensley.scss.css?v=135609760454298588281781304538",
    "enabled": true,
    "fontVariant": "unset",
    "useInitials": true,
    "useName": true,
    "useMonogram": true,
    "fontScale": 1
  }
];
*/
var personalization_fonts = [ "Century", "Signet Roundhand", "Typography Times" ];
var personalization_fontFiles = [ "Century", "Signet Roundhand", "Typography_Times_2" ];;
var personalization_monogram_fonts = [ "CircleBlock", "CircleScript", "Diamond" ];

var form = $('.personalization-form').first();
var addToCartButton = $(".add-to-cart input").first();

$(function() {
  
  var body;
      
  body = $(document.body);

  var is_product = body.hasClass("product");
  var is_cart = body.hasClass("cart");
    
  if(is_product) {

    product_init();
  }
});

function product_init() {

    // Personalization events
    $('select.product-personalization').change(function() {
      // Reset form, form.reset() will not work, must select only personalization inputs.
      let inputs = document.querySelectorAll(".personalization-form input[data-personalization]")
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = "";
      }
      render_personalization();
    });
    $('.personalization-date input.datepicker').change(function() { change_date(); });
    $('.personalization-date input.dateformat').change(function() { validate_date(); });
    $('.personalization-text input').keyup(function() { validate_personalization(); });

    // Hide personalization select if there is only one variant
    $('.product-personalization').filter(function() {

        return jQuery(this).find('option').size() === 1

    }).hide();

    render_personalization();



  $(".initial-input").keyup(function () {
    if (this.value.length == this.maxLength) {
      $(this).parent().next().find(".initial-input").focus();
    }
    var initials = '';
    $(".initial-input").map(function(){
      initials += $(this).val();
    });
    $(".initials-text-input").val(initials);
    render_preview();
  });
}


function render_personalization() {
    $('.personalization-text .initials-text-input').val('');
    $('.personalization-text .input-container .initial-input').val('');
    personalization_type = $('.product-personalization').first().val();
    var form = $('.personalization-form').first();
    var description = $('.personalization-description').first();

    if(personalization_type === 'Monogram' || personalization_type === 'Initials' || personalization_type === 'Name') {

        var style;
        var text = $('.personalization-text').first();
        var text_input = $('.personalization-text input').first();
        var date_picker = $('.personalization-date .datepicker').first();
        var date_font_palette = $('.personalization-date-font .palette').first();
        var dateOptions = $('.personalization-date-format').first();
        var text_input_limit = $('input[name="personalize_meta_limit"]').val();
        if(text_input_limit == '') { text_input_limit = 30; }

        var text_initial_limit = $('input[name="personalize_meta_init_limit"]').val();
        if (text_initial_limit == '') { text_initial_limit = 4; }

        // Enable inputs
        form.find('input, textarea, button, select').prop("disabled", false);

        // Slide in personalization form
        form.slideDown();

        // Build personalization colors
        if( $('.personalization-color .palette').html().length === 0 ) { build_colors(); }

        // Build personalization fonts
        if( $('.personalization-font .palette').html().length === 0 ) { build_fonts(); }

        // Hide the date
        var datePicker = document.querySelector('.datepicker[data-personalization]');
    
        if (datePicker) {
          datePicker.removeAttribute('name');
        }

        // Setup/switch the various personalization types
        switch(personalization_type) {

            case 'Monogram' :
                // Set data-type
                form.attr('data-type', 'monogram');

                $('.personalization-initial-input-container').show();
                $('.personalization-initial-input-container input.initial-input').each(function (index, input) {
                  var originalName = input.getAttribute('data-name');
                  input.name = originalName;
                });
                $('.initial-input.initial-input-monogram').hide();
                $('.initials-text-input').hide();
                $('.initials-text-input').removeAttr('name');

                $(".personalization-initial-input-container input").attr('required', true);
                if (!personalization_font || !personalization_font.useMonogram) {
                  build_fonts();
                  
                  var font = fontJSON.find(function (obj) {
                    return obj.fontName == 'CircleBlock';
                  });
              
                  personalization_font = font;
                }
				build_fonts();
                // Set input properties
                text.children('label').html('Initials');
                text_input.attr({
                maxlength: '3',
                placeholder: ' '
                });

                // Limit input length
                text_input.val(text_input.val().substr(0, 3));

                // Show description message
                description.fadeIn('150').children('p').html('Monogram is embroidered as <br/><strong>First, Last, Middle Initial.</strong>');

                break;

            case 'Initials' :
            case 'Name' :

                if (personalization_previous_type === null || personalization_previous_type === "Monogram") {
                    build_fonts();

                    if (!personalization_font || !personalization_font.useInitials) {
                      var font = fontJSON.find(function (obj) {
                        return obj.fontName == 'Garamond';
                      });
              
                      personalization_font = font;
                    }
                    $(".personalization-initial-input-container input").attr('required', false);
                }

                switch(personalization_type) {

                    case 'Initials' :

                        // Set data-type
                        form.attr('data-type', 'initials');
                        build_fonts();
                        var font = fontJSON.find(function (obj) {
                          return obj.fontName == 'Century';
                        });

                        personalization_font = font;
                        $('.personalization-initial-input-container').hide();
                        $('.personalization-initial-input-container input.initial-input').each(function (index, input) {
                          input.removeAttribute('name');
                        });
                        $('.initials-text-input').show();
                        $('.initials-text-input').attr('name', 'properties[Text]');


                        // Set input properties
                        text.children('label').html(personalization_type);
                        text_input.attr({
                        placeholder: 'ABCD'
                        });

                        

                        // Show description message
                        description.fadeIn('150').children('p').html('Initials display as <span style="white-space: pre;"><strong>First</strong> <strong>Middle</strong> <strong>Last</strong></span>');

                        break;

                    case 'Name' :

                        // Set data-type
                        form.attr('data-type', 'full-name');
                        build_fonts();
                        var font = fontJSON.find(function (obj) {
                          return obj.fontName == 'Century';
                        });

                        personalization_font = font;
                        $('.personalization-initial-input-container').hide();
                        $('.personalization-initial-input-container input.initial-input').each(function (index, input) {
                          input.removeAttribute('name');
                        });
                        $('.initials-text-input').show();
                        $('.initials-text-input').attr('name', 'properties[Text]');

                        var datePicker = document.querySelector('.datepicker[data-personalization]');
    
                        if (datePicker) {
                          var originalName = datePicker.getAttribute('data-name');
                    
                          datePicker.name = originalName;
                        }

                        // Set input properties
                        text.children('label').html(personalization_type);
                        text_input.attr({
                        maxlength: text_input_limit,
                        placeholder: 'Full Name'
                        });

                        // Limit input length

                        text_input.val(text_input.val().substr(0, text_input_limit));

                        // Hide description message
                        description.hide();

                        // Init date picker
                        date_picker.datepicker({ dateFormat: 'm-dd-yy' });

                        // Build date fonts
                        personalization_date_font = "Century";

                        break;
                }

                break;
        }

        // Init Canvas
        // Wait for images to load before rendering preview on first run
        if(personalization_previous_type === null) {
            personalization_texture.src = $(".personalization-color input:checked + img")[0].src;
            $(personalization_texture).on("load", { view: this }, function(event) {
                _this = event.data.view;
                validate_personalization();
            });
        } else {
            validate_personalization();
        }

        // Set global previous type
        personalization_previous_type = personalization_type;

    } else {

        // No Personlization
        var message = $(".product-message").first();
        var cartButton = addToCartButton;

        form.slideUp('200', function() {
            // Close personalization form
            description.hide();
            // Remove validation errors and allow checkout
            message.hide().children("p").empty();
            cartButton.val('Add to cart').removeClass("disabled").prop("disabled", false);
        });

        // Disable inputs
        form.find('input, textarea, button, select').prop("disabled", true);
    }
}



function build_colors() {

          var colorImage, colorImageUrl;
          var colors = personalization_colors_json;
          var el = $('.personalization-color .palette');
          var colors_available = $('input[name="personalize_meta_colors"]').val();
          el.html("");

          if(colors_available != '') {
			colors = [];
            var available_colors = colors_available.split(',');

            for (var i = 0; i < available_colors.length; i++) {
              var color_object = personalization_colors_json.find(function (val) {
                return val.color.toUpperCase() == available_colors[i].trim().toUpperCase();
              });
              
              if (color_object) {
              	// Convert the color to RGB
                var rgbCode = tinycolor(color_object.hex).toRgb();
                
                // Create the image
                var c = document.createElement('canvas');
                c.height = 1;
                c.width = 1;
                
                var ctx = c.getContext("2d");
                var imgData = ctx.createImageData(1, 1);
                var i2;
                for (i2 = 0; i2 < imgData.data.length; i2 += 4) {
                  imgData.data[i2+0] = rgbCode.r;
                  imgData.data[i2+1] = rgbCode.g;
                  imgData.data[i2+2] = rgbCode.b;
                  imgData.data[i2+3] = 255;
                }
                ctx.putImageData(imgData, 0, 0);
                color_object['base64'] = c.toDataURL();
                colors.push(color_object);
              }
            }

//        for(var color_index in colors) {
//
//            var color = colors[color_index];
//            color = $.trim(color);
//            color = color.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
//            colors[color_index] = color;
//        }
    }

          
    $.each(colors, function(index, element) {
      el.append('<label title="' + this.color + '"><input type="radio" name="properties[Color]" value="' + this.color + '" ' + (index === 0 ? 'checked ' : '') + ' style="background-color: ' + this.hex + '" /><img src="' + this.base64 + '" class="' + this.color + '" /></label>');
      if (index === 0) {
        var label = $('input[type=radio][name="properties[Color]"][value="' + this.hex + '"]').closest('.input-wrapper').find('.color-selection');
        label.html(this.color);
      }
	});
    
    var selectedColor = $('input[type=radio][name="properties[Color]"]:checked');
    var label = selectedColor.closest('.input-wrapper').find('.color-selection');
    label.html(selectedColor.val());
          
    /*for(var i = 0; i < colors.length; i++) {
        colorImage = colors[i].replace(/\s+/g, "_") + "_Tex.jpg";
        colorImageUrl = assetCdnUrl.replace("__URL__", colorImage);
        el.append('<label title="' + colors[i] + '"><input type="radio" name="properties[Color]" value="' + colors[i] + '" ' + (i === 0 ? 'checked ' : '') + '/><img src="' + colorImageUrl + '" class="' + colors[i] + '" /></label>');
    }*/

    $('.personalization-color input').click(function() {
		var label = $(this).closest('.input-wrapper').find('.color-selection');
        var colorImageUrl = $(this).next().attr('src');
      	label.html($(this).closest('label').attr('title'));
        personalization_texture.src = colorImageUrl;
        render_preview();
        render_date_preview();
    });
}

function build_fonts() {
  var fonts = fontJSON;
  var el = $('.personalization-font .palette');

  for (var i = 0; i < fonts.length; i++) {
    var font = fonts[i];
    
    if (font.enabled) {
      var fontLoaded = (($('link[data-font-name="' + font.fontName + '"]').length > 0) ? true : false);
      
      if (!fontLoaded) {
        var stylesheet = document.createElement('link');
        stylesheet.setAttribute("type", "text/css");
        stylesheet.setAttribute("rel", "stylesheet");
        stylesheet.setAttribute("data-font-name", font.fontName);
        stylesheet.setAttribute("href", font.fontStylesheet);

        var preloadSpan = document.createElement('span');
        preloadSpan.style.fontFamily = font.fontName;

        document.body.appendChild(stylesheet);
        document.body.appendChild(preloadSpan); // Load the font before we need it
      }
    }
  }
  
  el.html("");
  
  switch (personalization_type) {
    case "Name":
      
      console.log("FINDING FONTS - NAME");
      var availableFonts = fonts.filter(function (obj) {
        return (obj.enabled && obj.useName);
      });

      for (var i = 0; i < availableFonts.length; i++) {
        var font = availableFonts[i];
        var useName = font.useName;
        if(useName){
        if(font.fontPrevImg){
          var fontImage = font.fontPrevImg.replace(/\s+/g, "_") + '_x40.png';
        }else {
          var fontImage = font.fontName.replace(/\s+/g, "_") + '_x40.png';
        }
        fontImage = assetCdnUrl.replace("__URL__", fontImage);
         
        el.append('<label title="' + font.fontTitle + '"><input type="radio" name="properties[Font]" value="' + font.fontLabel + '" ' + (i === 0 ? 'checked ' : '') + '/><img src="' + fontImage + '" class="' + font.fontTitle + '" /></label>');
        //el.append('<label title="' + font.fontTitle + '"><input type="radio" name="properties[Font]" value="' + font.fontName + '" ' + (counter === 0 ? 'checked ' : '') + ' /><span class="font-sample" style="font-family: \'' + font.fontName + '\'">ABC</span></label>');

        if (i === 0) {
          $('.font-name').text(font.fontLabel);
        }
      }
      }
      break;
    case "Initials":
      
      console.log("FINDING FONTS - INITIAL");
      
      var availableFonts = fonts.filter(function (obj) {
        return (obj.enabled && obj.useInitials);
      });

      for (var i = 0; i < availableFonts.length; i++) {
        var font = availableFonts[i];
        var useInitials = font.useInitials;
        if(useInitials){
          if(font.fontPrevImg){
            var fontImage = font.fontPrevImg.replace(/\s+/g, "_") + '_x40.png';
          }else {
            var fontImage = font.fontName.replace(/\s+/g, "_") + '_x40.png';
          }
        fontImage = assetCdnUrl.replace("__URL__", fontImage);
         
        el.append('<label title="' + font.fontTitle + '"><input type="radio" class="initials-font-option-swatch" name="properties[Font]" value="' + font.fontLabel + '" ' + (i === 0 ? 'checked ' : '') + ' maxlength="'+ font.limit +'"/><img src="' + fontImage + '" class="' + font.fontTitle + '" /></label>');

        if (i === 0) {
          $('.font-name').text(font.fontLabel);
        }
      }
    }
      $('.initials-text-input').attr('maxlength', $('.initials-font-option-swatch').first().attr('maxlength'));


      break;
    default:
      
      console.log("FINDING FONTS - MONO");
      var availableFonts = fonts.filter(function (obj) {
        return (obj.enabled && obj.useMonogram);
      });

      for (var i = 0; i < availableFonts.length; i++) {
        var font = availableFonts[i];
        //var useName = font.useName;
        //var useInitials = font.useInitials;
        var useMonogram = font.useMonogram;
        if(useMonogram){
          if(font.fontPrevImg){
            var fontImage = font.fontPrevImg.replace(/\s+/g, "_") + '_x40.png';
          }else {
            var fontImage = font.fontName.replace(/\s+/g, "_") + '_x40.png';
          }
        fontImage = assetCdnUrl.replace("__URL__", fontImage);
         
        el.append('<label title="' + font.fontTitle + '"><input type="radio" name="properties[Font]" value="' + font.fontLabel + '" ' + (i === 0 ? 'checked ' : '') + '/><img src="' + fontImage + '" class="' + font.fontTitle + '" /></label>');
        if (i === 0) {
          $('.font-name').text(font.fontLabel);
        }

      }
      }
      break;
  }
  
  $('.personalization-font input').change(function() {
    var selectedFont = $(this).val();
    var font = fontJSON.find(function (obj) {
      return obj.fontLabel == selectedFont;
    });

    $(".initials-text-input").attr('maxlength', $(this).attr('maxlength'));

    //only clear input for initials
    if(personalization_type == "Initials"){
      $('.initials-text-input').val('');
    }

    
    
    personalization_font = font;
    $('.font-name').text(font.fontLabel);
    render_preview();
    render_date_preview();
  });
  
  el.addClass('initialized');  
}

function change_date(e) {
    $('.personalization-date-format').css('display', 'flex');
    validate_date();
}

function render_preview(e) {

    var printDateFont, newString, final, chars, char1, char2, char3, pattern;

    // Setup canvas
    var canvas = $(".personalization-preview .canvas")[0];
    var ctx = canvas.getContext("2d");

    // Set preview class
    var colorClass = $('.personalization-color input:checked').first().val().toLowerCase().replace(/\s|_+/g, "-");

    // Background color is set in meta data, choose appropriate class
    var personalization_meta_back = $('input[name="personalize_meta_back"]').val();

    if (personalization_meta_back.length == 0) {
      // Attempt to parse out of the product title
      var title = $('h1.h3[data-type="product-title"]').text().toLowerCase();
      var colors = title.split(' ');
      
      var colorObject = personalization_background_colors.find(function (obj) {
        var name = obj.color.replace(/meta/g, '');
        name = name.replace(/-/g, ' ');
        name = name.trim();

        return (title.indexOf(name) > -1);
      });

      if (colorObject) {
        personalization_meta_back = colorObject.color.toLowerCase().replace(/ /g, '-');
        //console.log('Found Color:', personalization_meta_back);
      }
    }

    if(personalization_meta_back != '') {
      if (!personalization_meta_back.startsWith('meta-')) {
        if (!personalization_meta_back.startsWith('#')) {
          var handleized = personalization_meta_back.replace(/\s|_+/g, "-");
          colorClass = 'meta-' + handleized;
        } else {
          colorClass = personalization_meta_back;
        }
      } else {
        colorClass = personalization_meta_back.replace(/\s|_+/g, "-");
      }
    }

    $('.personalization-preview .preview-area').first().attr('data-color', colorClass);
    //console.log('Color Class:', colorClass);
  
  	// Set the correct color for the preview
  	var previewArea = $('.personalization-preview .preview-area');
    var colorObject = personalization_background_colors.find(function (obj) {
      return obj.color == colorClass.toLowerCase();
    });
  
    var color;
    if (colorObject) {
      color = tinycolor(colorObject.hex);
    } else {
      color = tinycolor(colorClass);
    }

    var colorRGB = color.toRgbString();
    var transparentRGB = color.setAlpha(.8).toRgbString();
    var transparentHex = color.setAlpha(.8).toHex8String();
    var mozillaStyle = {
      "background": "-moz-radial-gradient(center, ellipse cover, rgba(247,229,228,1) 0%, rgba(247,229,228,0.4) 70%, rgba(247,229,228,0.4) 100%);"
    };
    var webkitStyle = {
      "background": "-webkit-radial-gradient(center, ellipse cover, rgba(247,229,228,1) 0%,rgba(247,229,228,0.4) 70%,rgba(247,229,228,0.4) 100%);"
    };
    var standardsStyle = {
      "background": "radial-gradient(ellipse at center, rgba(247,229,228,1) 0%,rgba(247,229,228,0.4) 70%,rgba(247,229,228,0.4) 100%);"
    };
    var IEStyle = {
      "filter": "progid:DXImageTransform.Microsoft.gradient( startColorstr='#f7e5e4', endColorstr='#66f7e5e4',GradientType=1 );"
    };
    
    var styleObject = [
      "background: -moz-radial-gradient(center, ellipse cover, " + colorRGB + " 0%, " + transparentRGB + " 70%, " + transparentRGB + " 100%)",
      "background: -webkit-radial-gradient(center, ellipse cover, " + colorRGB + " 0%," + transparentRGB + " 70%," + transparentRGB + " 100%)",
      "background: radial-gradient(ellipse at center, " + colorRGB + " 0%," + transparentRGB + " 70%," + transparentRGB + " 100%)",
      "filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='" + color + "', endColorstr='" + transparentHex + "',GradientType=1 )"
    ].join(';');
    
    
    previewArea.attr('style', styleObject);

    // Setup text
    //var $this = typeof e !== "undefined" ? e.target : $('.personalization-text input')[0];
    var $this = $('.personalization-text .initials-text-input');
    var text = $this.val();
    var size = "30px";

    // Choose fonts
    var font = personalization_font;
    var dateFont = font;

    switch(personalization_type) {

        case 'Monogram' :
            if((typeof(text) === 'undefined') || (text.length < 3)) { text = "ABC"; }

                // Restrict characters A-Z
                for(var i = 0; i < text.length; i++) {
                if(!((text.charCodeAt(i) >= 65 && text.charCodeAt(i) <= 90) || (text.charCodeAt(i) >= 97 && text.charCodeAt(i) <= 122))) {
                $this.val(function(index, value){return value.substr(0, value.length - 1);});
                }
            }

            // Flip initials around
            newString = text[0];
            newString += text[2];
            newString += text[1];
            text = newString;

            break;

        case 'Initials' :
            var fontSize = 125 * font.fontScale;
           // console.log(font.fontName);
            if(font.fontName == 'Garamond'){
              fontSize = 100;
            }
            size = fontSize + 'px';
            //render placeholder depending on font character limit
            var placeholder = "ABCD"; 
            if((typeof(text) === 'undefined') || (text.length === 0)) { text = placeholder.substring(0, font.limit); }

            break;

        case 'Name' :

            printDateFont = font; //@TODO set this.personalziationDateFont;
            var fontSize = 60;
        
            if(text.length < 7) {
              fontSize = 50;
              //size = "50px";
            } else if(text.length < 14) {
              fontSize = 40;
              //size = "40px";
            } else if(text.length < 21) {
              fontSize = 35;
              //size = "35px";
            } else {
              fontSize = 30;
              //size = "30px";
            }
        
        	size = fontSize * font.fontScale;
        	size = size + 'px';

            if((typeof(text) === 'undefined') || (text.length === 0)) { text = "Full Name"; }

            break;
    }

    if(personalization_type === "Monogram") {
        text = text.toUpperCase();

        switch(font.fontName) {

            case 'CircleBlock' :
				var fontSize = 375 * font.fontScale;
                size = 300 + "px";
                final = '';
                chars = "!\"#$%&'()*+,-./0123456789:";
                final += chars[text.charCodeAt(0) - 65];
                final += text[1];
                text = text.toLowerCase();
                final += text[2];
                text = final;
                largeMiddle = true;
                break;

            case 'CircleScript' :
				var fontSize = 150 * font.fontScale;
                size = 150 + "px";
                char1 = 58880 + ((text.charCodeAt(0) - 65) * 3 + 1);
                char2 = 58880 + ((text.charCodeAt(1) - 65) * 3 + 0);
                char3 = 58880 + ((text.charCodeAt(2) - 65) * 3 + 2);
                text = String.fromCharCode(char1) + String.fromCharCode(char2) + String.fromCharCode(char3);
                largeMiddle = true;
                break;

            case 'Diamond' :
				var fontSize = 235 * font.fontScale;
                size = 200 + "px";
                char1 = 58880 + 52 + text.charCodeAt(0) - 65;
                char2 = 58880 + 26 + text.charCodeAt(1) - 65;
                char3 = 58880 + 0 + text.charCodeAt(2) - 65;
                text = String.fromCharCode(char1, char2, char3);
                largeMiddle = true;
                break;
            
            case 'Century' :
        var fontSize = 100;
                size = fontSize + "px";
                largeMiddle = true;
                break;

            case 'Code Bold' :
        var fontSize = 100;
                size = fontSize + "px";
                largeMiddle = true;
                var posVal = 10;
                break;

            case 'Madina' :
        var fontSize = 100;
              size = fontSize + "px";
              largeMiddle = true;
              var scaleSize = .3;
              break;
        
            case 'Wensley' :
        var fontSize = 100;
              size = fontSize + "px";
              largeMiddle = true;
              break;
        
            case 'Bookman' :
        var fontSize = 100;
              size = fontSize + "px";
              largeMiddle = true;
              break;

        }          
    }else if(personalization_type === "Name") {
      switch(font.fontName) {
        case 'Madina' :
                var fontSize = 100;
                size = fontSize + "px";
                break;
        case 'Hello Honey' :
                var fontSize = 100;
                size = fontSize + "px";
                break;
        case 'Keep Calm' :
                var fontSize = 40;
                text = text.split("").join(String.fromCharCode(8202))
                text = text.toUpperCase();
                size = fontSize + "px";
                break;
        case 'Code Bold' :
                text = text.split("").join(String.fromCharCode(8202))
                break;
        case 'Pistara' :
                text = text.split("").join(String.fromCharCode(8202))
                break;
      }

    }else if(personalization_type === "Initials") {
      switch(font.fontName) {
        case 'clarendon-wide' :
          var fontSize = 90;
          size = fontSize + "px";
          break;
        case 'Century' :
          var fontSize = 100;
          size = fontSize + "px";
          break;
        case 'Cruncho' :
          var fontSize = 170;
          size = fontSize + "px";
          break;
        case 'CFDiamond' :
          var fontSize = 160;
          size = fontSize + "px";
          break;
      } 
    }

    if (font.fontVariant == 'uppercase') {
      text = text.toUpperCase(); 
    }

    // Render personalization
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.shadowColor = "black";
    ctx.shadowBlur = 2;

    ctx.font = size + " " + font.fontName;

    //console.log(text.length);
    var metrics = ctx.measureText(text);
    var actualwidth = metrics.width;
    var fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
    var actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
   //console.log('actualwidth:', actualwidth, 'actualHeight:', actualHeight,'fontHeight:', fontHeight);

    //canvas origin
    var canvasWidth = canvas.width;
    var canvasHeight = canvas.height;
    var canvasPositionX = canvasWidth / 2;
    var canvasPositionY = canvasHeight / 2;

    //find origin
    var positionX = actualwidth / 2;
    var positionY = actualHeight / 2;
    var origin = `${positionX}, ${positionY}`;
    var shift = actualwidth / text.length;

    //console.log(origin);
    //console.log('shift', shift);
    //console.log(canvasPositionX);
    if(personalization_type === "Monogram"){
      //console.log(font.fontName);
      for(var letter = 0; letter < text.length; letter++){  
        //console.log(text[letter]);
        if(letter == 1) {
          ctx.font = size + " " + font.fontName;
          ctx.fillText(text[letter], + canvasPositionX, canvasPositionY);
        } else {
          if(letter == 0){
            if(largeMiddle){
              var scale = scaleSize ? scaleSize : 0.2
              ctx.font = (fontSize - fontSize * scale) + "px" + " " + font.fontName;
            }
            //console.log(text[letter], positionX - shift + canvasPositionX - positionX, canvasPositionY);
            var modPos = posVal ? posVal : 0;
            ctx.fillText(text[letter], positionX - shift + canvasPositionX - positionX - modPos, canvasPositionY);
          }else {
            if(largeMiddle){
              var scale = scaleSize ? scaleSize : 0.2
              ctx.font = (fontSize - fontSize * scale) + "px" + " " + font.fontName;
            }
            var modPos = posVal ? posVal : 0;
            //console.log(text[letter], positionX + shift + canvasPositionX - positionX, canvasPositionY);
            if(font.fontName == "Madina" && text[1] == 'T' && text[0] != 'L'){
              shift = 90;
            }

            //when last initial is Madina AND L
            // Shift should be wider
            if (font.fontName == "Madina" && text[1] == 'L') {
              shift = shift + 35;
            } 

            //General rule of thumb for madina
            if(font.fontName == "Madina"){
              //Reduce by 15 everytime for closer feel
              shift = shift - 15;
            }
            ctx.fillText(text[letter], positionX + shift + canvasPositionX - positionX + modPos, canvasPositionY);
          }
        }
      }
    }else if(personalization_type === "Initials") {
      //for(var letter = 0; letter < text.length; letter++){  
      //  console.log(`text[${letter}]`,text[letter]);
      //}        
      //console.log('Font Name:', font.fontName);
      //console.log(text);
      if(font.fontName == "Mongolian Baiti"){
        text = text.split('');
        text = text.map(function(value) { 
          return value + '.';
        });
        text = text.join('');
        ctx.fillText(text, canvasPositionX, canvasPositionY);
        
      }else {
        if(font.fontName == "Signet Roundhand"){
          ctx.fillText(text, canvasPositionX - 30, canvasPositionY);
        }else {
          ctx.fillText(text, canvasPositionX, canvasPositionY);
        }
      }

    }else{
      ctx.fillText(text, canvasPositionX, canvasPositionY);
    }



    if(font.cartName == 'Bookman'){
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.arc(canvasPositionX, canvasPositionY, actualwidth / 2 + 10, 0, 2 * Math.PI);
      ctx.stroke();
    }


    //finding center of box
    //ctx.fillText(text, ctx.canvas.width / 2, ctx.canvas.height / 2);

    // Apply texture to personalization
    ctx.globalCompositeOperation = "source-atop";
    pattern = ctx.createPattern(personalization_texture, 'repeat');
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = pattern;
    ctx.fill();

    ctx.restore();
}

function render_date_preview(date) {

    var pattern;

    // Setup date canvas
    var canvas = $(".personalization-preview .date-canvas")[0];
    var ctx = canvas.getContext("2d");
    var font = personalization_font;

    if( typeof date === 'undefined' ) {

        date = $('.personalization-date .datepicker').first().val();
		date = dateProperFormat(date);
    }
  
    if (font.fontVariant == 'uppercase') {
      date = date.toUpperCase();
    }

    var fontSize = 40 * font.fontScale;

    // Render personalization
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = fontSize + "px " + font.fontName;
    ctx.shadowColor = "black";
    ctx.shadowBlur = 2;
    ctx.fillText(date, ctx.canvas.width / 2, ctx.canvas.height / 2);

    // Apply texture to personalization
    ctx.globalCompositeOperation = "source-atop";

    pattern = ctx.createPattern(personalization_texture, 'repeat');
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = pattern;
    ctx.fill();

    ctx.restore();
}

function validate_personalization() {

    var valid = false;
    var text = $('.personalization-text input').first().val();

    if( typeof text !== 'undefined') {
        if(text.length > 0) {
            if( personalization_type === "Monogram" && text.length !== 3 ) { valid = false; } else { valid = true; }
        }
        render_preview();
    }

    // Set button and message
    if(valid === true) {
        render_preview();
        if(addToCartButton.attr('disabled') !== undefined) {
        addToCartButton.val('Add to cart').removeClass("disabled").prop("disabled", false);
        }
        $(".product-message").hide().children("p").empty();
        } else{
        addToCartButton.val('Add to cart').addClass("disabled").prop("disabled", true);
        $(".product-message").show().addClass("box-error").removeClass("box-success").children("p").html("A required personalization field is missing or invalid.");
    }
}
  
  function dateProperFormat(date) {
    var result = '';
    var month = '';
    var day = '';
    var year = '';
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var valid = true;
    var dateFormat = $('.personalization-date .dateformat').first();

    var stage = 0;
    for (var i = 0; i < date.length; i++) {
      if (date[i] === '-') {
        stage++;
      } else {
        if(stage === 0){ month += date[i]; }
        if(stage === 1){ day += date[i]; }
        if(stage === 2){ year += date[i]; }
      }
    }

    month = parseInt(month);
    day = parseInt(day);
    year = parseInt(year);

    if(isNaN(month) || month < 1 || month > 12 || month.toString().length > 2) { valid = false; }
    if(isNaN(day) || day < 1 || day > 31 || day.toString().length > 2) { valid = false; }
    if(isNaN(year) || year < 1 || year > 9999 || year.toString().length !== 4) { valid = false; }
    if(stage > 2) { valid = false; }

    if (valid === true) {
      result = month + '-' + day + '-' + year;

      if (dateFormat.prop('checked') === true) {
        result = months[month - 1] + ' ' + day + ', ' + year; 
      }
    }

    return result;
  }

function validate_date() {

    var printDate, formattedDate;
    var month = '', day = '', year = '';
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var valid = true;
    var date = $('.personalization-date .datepicker').first().val();
    var dateFormat = $('.personalization-date .dateformat').first();

    var stage = 0;
    for(var i = 0; i < date.length; i++) {
        if(date[i] === '-') {
            stage++;
        } else {
            if(stage === 0){ month += date[i]; }
            if(stage === 1){ day += date[i]; }
            if(stage === 2){ year += date[i]; }
        }
    }

    month = parseInt(month);
    day = parseInt(day);
    year = parseInt(year);

    if(isNaN(month) || month < 1 || month > 12 || month.toString().length > 2) { valid = false; }
    if(isNaN(day) || day < 1 || day > 31 || day.toString().length > 2) { valid = false; }
    if(isNaN(year) || year < 1 || year > 9999 || year.toString().length !== 4) { valid = false; }
    if(stage > 2) { valid = false; }

    if(valid === true) {
        printDate = month + '-' + day + '-' + year;

        // Formatted Date
        if( dateFormat.prop('checked') === true ){
            printDate = months[month - 1] + ' ' + day + ', ' + year;
            $('personalization-date-format').first().closest('em').html(printDate);
        }

        render_date_preview(printDate);
    }
}

// Quantity input box functions
// Init min quantity checks (on any input field with data-min-quantity attribute)
(function(){
  var quantityObjs = document.querySelectorAll('input.quantity-field');
  for (i = 0; i < quantityObjs.length; i++) {

    var quantityObj = quantityObjs[i];
    var quantityMin = parseInt(quantityObj.getAttribute('data-min-quantity'));
    var quantityInc = parseInt(quantityObj.getAttribute('data-unit-quantity')); // Quantity Increment
    var quantityQty = parseInt(quantityObj.value);
    var form = $(quantityObj).closest('form');
    var error_shown = false;

    // Check qty input on enter keypress
    form.bind('keydown', function(e) {
      if(e.keyCode == 13) { // && parseInt(quantityObj.value) < quantityMin) {
        e.preventDefault;
        errorCheck(quantityObj);
        document.activeElement.blur();
        return false;
      }
    });

    // Set initial qty to min qty
    if(quantityMin > 0) {
      if(quantityQty < quantityMin) {
        quantityObj.value = quantityMin;
      }

      // Check qty input on click-away
      quantityObj.addEventListener('change', function() {
        errorCheck(this);
      });

      // Decrease qty by increment amount(unit-quntity)
      var btnIncDecr = quantityObj.previousElementSibling;
      if(quantityInc > 0 && btnIncDecr.classList.contains('button-decr')){
        btnIncDecr.addEventListener('click', function() {
          var input = this.nextElementSibling;
          if(input.type == 'text') {
            incrementQty(input, "-1");
          } else {
            return false;
          }
        }, false);
      }

      // Increase qty by increment amount(unit-quntity)
      var btnIncIncr = quantityObj.nextElementSibling;
      if(quantityInc > 0 && btnIncIncr.classList.contains('button-incr')){
        btnIncIncr.addEventListener('click', function() {
          var input = this.previousElementSibling;
          if(input.type == 'text') {
            incrementQty(input, "1");
          } else {
            return false;
          }
        }, false);
      }
    }
  }

  function incrementQty(input, direction) {
    var quantity = parseInt(input.value);
    var increment = parseInt(input.getAttribute('data-unit-quantity'));
    var direction = parseInt(direction);
    var change = document.createEvent('HTMLEvents');
    change.initEvent('change', true, false);
    // Change value, check if valid, fire "change" event (in that order)
    input.value = quantity + (increment * direction);
    errorCheck(input);
    input.dispatchEvent(change);
  }

  function errorCheck(quantityObj) {

    var quantity = parseInt(quantityObj.value);
    var quantityMin = parseInt(quantityObj.getAttribute('data-min-quantity'));
    var quantityUnit = parseInt(quantityObj.getAttribute('data-unit-quantity'));
    var container = quantityObj.parentNode;
    var notification = container.getElementsByClassName('notification');
    if(notification) { notification = notification[0]; }

    if(quantity < quantityMin) {

      quantityObj.value = quantityMin;

      if(typeof(notification) === 'undefined'){
        
        container.insertAdjacentHTML('beforeend', '<div class="notification box-warning small"><p>Quantity must be ' + quantityMin + ' or more.</p></div>');
        quantityObj.style.outline = '#f27474 auto 5px';
      }

    } else {

      if(notification) {

        quantityObj.style.outline = null;
        notification.remove();
      }
    }

    var quantityRounded = roundToNearest((quantity - quantityMin), quantityUnit);
    if(quantityRounded != (quantity - quantityMin)) {
      
      quantity = quantityRounded + quantityMin;
      quantityObj.value = quantity;
    }
  }

  function roundToNearest( number, multiple ){
    var half = multiple/2;
    return number+half - (number+half) % multiple;
  }
})();

(function(){
  $("#mc_embed_signup_scroll .newsletter-input").focus(function() {
    $(this).siblings('label').addClass('active');
  });
  $(".header-search .search-input").focus(function() {
    $(this).siblings('label').addClass('active');
  });
  $("#mc_embed_signup_scroll .newsletter-input").blur(function() {
    $(this).siblings('label').removeClass('active');
  });
  $(".header-search .search-input").blur(function() {
    $(this).siblings('label').removeClass('active');
  });
  
  $(document).on('click', '.mmm-link-block', function () {
    $(document.documentElement).animate({
        scrollTop: 0
    }, 500);
  });

})();
